import { TabItem, Tabs } from '@/lib';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { RouteConstants } from '@/features/router/RouteConstants';
import { PageLayout } from '@/global/components';
import { CampaignHeader } from './CampaignHeader';
import { CampaignsWhatsappWorkspaceV2 } from './components/CampaignsWhatsappWorkspaceV2';
import { CampaignsSmsWorkspaceV2 } from './components/CampaignsSmsWorkspaceV2';
import { CampaignsEmailWorkspaceV2 } from '@/features/campaigns/EmailCampaign';
import { getCampaignsChannelTabFromPathname } from './utils/getCampaignsChannelTabFromPathname';

const WHATSAPP_TAB_TITLE = 'campaign.tabs.whatsapp' as const;
const SMS_TAB_TITLE = 'campaign.tabs.sms' as const;
const EMAIL_TAB_TITLE = 'campaign.tabs.email' as const;

const CAMPAIGN_CHANNEL_TABS: TabItem[] = [
  {
    id: 'whatsapp',
    title: WHATSAPP_TAB_TITLE,
    element: <CampaignsWhatsappWorkspaceV2 />,
  },
  {
    id: 'sms',
    title: SMS_TAB_TITLE,
    element: <CampaignsSmsWorkspaceV2 />,
  },
  {
    id: 'email',
    title: EMAIL_TAB_TITLE,
    element: <CampaignsEmailWorkspaceV2 />,
  },
];

export const CampaignsV2 = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const tabId = getCampaignsChannelTabFromPathname(pathname) ?? 'whatsapp';

  const currentTab = CAMPAIGN_CHANNEL_TABS.find((item) => item.id === tabId) ?? CAMPAIGN_CHANNEL_TABS[0];

  const handleSelectTab = (tabItem: TabItem) => {
    if (!tabItem.id) {
      return;
    }

    history.push(`${RouteConstants.campaigns}/${tabItem.id}`);
  };

  return (
    <PageLayout>
      <div className='w-full grid grid-cols-1 gap-4'>
        <CampaignHeader />
        <Tabs items={CAMPAIGN_CHANNEL_TABS} currentTab={currentTab.title} onSelectTab={handleSelectTab} />
      </div>
    </PageLayout>
  );
};
